<template>
    <div class="data-table-box">
        <div class="title">1.可编辑数据表格</div>
        <edit-table
            :head="tableHead"
            :data="tableData"
            :pageInfo="pageInfo"
            toolBarFixed="right"
            rowKeyField="id"
            ref="editTable"
            :checkbox="true"
            :enableEdit="true"
            :showNumber="true"
            :showAdd="true"
            @delete="deleteData"
            toolBarWidth="200px">
            <template v-slot:toolbar="scope">
                <el-button
                    @click.stop="handleClick(scope,'edit')"
                    type="success"
                    icon="el-icon-edit-outline"
                    size="mini">
                    {{!scope.data.scope.row.enableEdit?'编辑':'确认'}}
                </el-button>
                <el-button
                    @click.stop="handleClick(scope,'del')"
                    type="danger"
                    icon="el-icon-delete"
                    size="mini">删除
                </el-button>
            </template>
            <template v-slot:state="sign">
                <el-tag size="mini" :type="sign.data === '禁用'? 'warning':''">
                    {{sign.data}}
                </el-tag>
            </template>
            <template v-slot:sign="sign">
                <el-tag size="mini" type="success">{{sign.data}}</el-tag>
            </template>
        </edit-table>

        <div class="title">2.表头拆分、单元格合并</div>
        <edit-table
            :head="tableHead2"
            :data="tableData"
            :pageInfo="pageInfo"
            :spanMethod="spanMethod"
            toolBarFixed="right"
            rowKeyField="id"
            ref="editTable"
            :checkbox="true"
            :enableEdit="false"
            :showNumber="true"
            :showAdd="false"
            toolBarWidth="200px">
            <template v-slot:toolbar="scope">
                <el-button
                    @click.stop="handleClick(scope,'look')"
                    type="primary"
                    icon="el-icon-tickets"
                    size="mini">
                    查看
                </el-button>
                <el-button
                    @click.stop="handleClick(scope,'del')"
                    type="danger"
                    icon="el-icon-delete"
                    size="mini">删除
                </el-button>
            </template>
            <template v-slot:state="sign">
                <el-tag size="mini" :type="sign.data === '禁用'? 'warning':''">
                    {{sign.data}}
                </el-tag>
            </template>
            <template v-slot:sign="sign">
                <el-tag size="mini" type="success">{{sign.data}}</el-tag>
            </template>
        </edit-table>

        <div class="title">3.自定义单元格样式（第二列字体颜色设置为红色 第四例字体颜色为蓝色 第二行背景色为灰色）(开启行可拖拽)</div>
        <edit-table
            :head="tableHead2"
            :data="tableData"
            :pageInfo="pageInfo"
            :cellStyle="cellStyle"
            toolBarFixed="right"
            rowKeyField="id"
            ref="editTable"
            :checkbox="true"
            :enableEdit="false"
            :showNumber="true"
            :showAdd="false"
            :enableDrag="true"
            toolBarWidth="200px">
            <template v-slot:toolbar="scope">
                <el-button
                    @click.stop="handleClick(scope,'look')"
                    type="primary"
                    icon="el-icon-tickets"
                    size="mini">
                    查看
                </el-button>
                <el-button
                    @click.stop="handleClick(scope,'del')"
                    type="danger"
                    icon="el-icon-delete"
                    size="mini">删除
                </el-button>
            </template>
            <template v-slot:state="sign">
                <el-tag size="mini" :type="sign.data === '禁用'? 'warning':''">
                    {{sign.data}}
                </el-tag>
            </template>
            <template v-slot:sign="sign">
                <el-tag size="mini" type="success">{{sign.data}}</el-tag>
            </template>
        </edit-table>

        <div class="title">4.表尾显示合计,自定义合计方法</div>
        <edit-table
            :head="tableHead3"
            :data="tableData"
            :pageInfo="pageInfo"
            :summaryMethod="getSummaries"
            toolBarFixed="right"
            rowKeyField="id"
            ref="editTable"
            :enableEdit="false"
            :showNumber="true"
            :showAdd="false"
            :showSummary="true"
            toolBarWidth="200px">
            <template v-slot:toolbar="scope">
                <el-button
                    @click.stop="handleClick(scope,'look')"
                    type="primary"
                    icon="el-icon-tickets"
                    size="mini">
                    查看
                </el-button>
                <el-button
                    @click.stop="handleClick(scope,'del')"
                    type="danger"
                    icon="el-icon-delete"
                    size="mini">删除
                </el-button>
            </template>
            <template v-slot:state="sign">
                <el-tag size="mini" :type="sign.data === '禁用'? 'warning':''">
                    {{sign.data}}
                </el-tag>
            </template>
            <template v-slot:sign="sign">
                <el-tag size="mini" type="success">{{sign.data}}</el-tag>
            </template>
        </edit-table>

        <div class="title">5.树型表格</div>
        <edit-table
            :head="tableHead3"
            :data="tableData3"
            :pageInfo="pageInfo"
            toolBarFixed="right"
            rowKeyField="id"
            ref="editTable"
            :enableEdit="false"
            :showNumber="true"
            :showAdd="false"
            toolBarWidth="200px">
            <template v-slot:toolbar="scope">
                <el-button
                    @click.stop="handleClick(scope,'look')"
                    type="primary"
                    icon="el-icon-tickets"
                    size="mini">
                    查看
                </el-button>
                <el-button
                    @click.stop="handleClick(scope,'del')"
                    type="danger"
                    icon="el-icon-delete"
                    size="mini">删除
                </el-button>
            </template>
            <template v-slot:state="sign">
                <el-tag size="mini" :type="sign.data === '禁用'? 'warning':''">
                    {{sign.data}}
                </el-tag>
            </template>
            <template v-slot:sign="sign">
                <el-tag size="mini" type="success">{{sign.data}}</el-tag>
            </template>
        </edit-table>

    </div>
</template>

<script>
    import '@/components/edit-table';
    import {toThousandFilter} from '@/filters'
    export default {
        name: "EditTableDemo",
        data() {
            return {
                pageInfo: {
                    total: 30000, // 总记录数
                    pageSizes: [10, 20, 50, 1000, 200],
                    offset: 10, // 每页显示多少条
                },
                tableHead: [
                    {
                        label: '员工编码',
                        property: 'id',
                        minWidth: 100,
                        hidden: true,
                        columnKey: 'id',
                        query: {  // 该列字段可查询
                            type: 'group-input'  // 查询框的类型  组合框（group-input） 文本框（textarea）
                            // 普通输入框（input）输入框组合（input-with-input） 选择框（select）日期选择框（time | date）
                        },
                    }, {
                        label: '员工姓名',
                        property: 'name',
                        minWidth: 100,
                        query: {  // 该列字段可查询
                            type: 'group-input'  // 查询框的类型  组合框（group-input） 文本框（textarea）
                            // 普通输入框（input）输入框组合（input-with-input） 选择框（select）日期选择框（time | date）
                        },
                    }, {
                        label: 'Email',
                        property: 'email',
                        minWidth: 200,
                        rules: {
                            required: true, message: '请输入Email', validator: val => {
                                if (!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(val)) return {msg: '请输入正确的邮箱', clear: false}
                            }
                        }
                    }, {
                        label: '状态',
                        property: 'state',
                        slot: 'state',
                        width: 80,
                        columnKey: 'state', // 用于标识哪一列 用于单元格点击事件  不设置则取
                        query: {  // 该列字段可查询
                            type: 'select',
                            value: 'open',
                            data: [
                                {label: '启用', value: 'open'},
                                {label: '禁用', value: 'close'},
                            ]

                        },
                    }, {
                        label: '注册时间',
                        property: 'created',
                        width: 150,
                        type: 'time',
                        columnKey: 'created', // 用于标识哪一列 用于单元格点击事件
                        sortable: true,
                    }, {
                        label: '用户标签',
                        slot: 'sign',
                        property: 'sign',
                        width: 100,
                        columnKey: 'sign'
                    }, {
                        label: '职位名称',
                        property: 'job',
                        width: 150,
                        type: 'select',
                        options: [
                            {
                                label: '开发',
                                value: '开发',
                            },
                            {
                                label: '运维',
                                value: '运维',
                            },
                            {
                                label: '管理',
                                value: '管理',
                            },],
                        rules: {
                            required: true, message: '请选择职位'
                        }
                    },
                ],
                // 表头拆分
                tableHead2: [
                    {
                        label: '员工编码',
                        property: 'id',
                        minWidth: 100,
                        columnKey: 'id',
                        sortable: true,
                    }, {
                        label: '个人信息',
                        minWidth: 100,
                        children: [
                            {
                                label: 'Email',
                                property: 'email',
                                minWidth: 200,
                            },
                            {
                                label: '员工姓名',
                                property: 'name',
                                minWidth: 100,
                            }
                        ]
                    }, {
                        label: '状态',
                        property: 'state',
                        slot: 'state',
                        width: 80,
                        columnKey: 'state', // 用于标识哪一列 用于单元格点击事件  不设置则取
                    }, {
                        label: '注册时间',
                        property: 'created',
                        width: 150,
                        type: 'date',
                        columnKey: 'created', // 用于标识哪一列 用于单元格点击事件
                        sortable: true,
                    }, {
                        label: '用户标签',
                        slot: 'sign',
                        property: 'sign',
                        width: 100,
                        columnKey: 'sign'
                    }, {
                        label: '职位名称',
                        property: 'job',
                        width: 150,
                    },
                ],
                tableHead3: [
                    {
                        label: '员工编码',
                        property: 'id',
                        minWidth: 100,
                        columnKey: 'id',
                    }, {
                        label: '员工姓名',
                        property: 'name',
                        minWidth: 100,
                    }, {
                        label: 'Email',
                        property: 'email',
                        minWidth: 200,
                    }, {
                        label: '状态',
                        property: 'state',
                        slot: 'state',
                        width: 80,
                        columnKey: 'state', // 用于标识哪一列 用于单元格点击事件  不设置则取
                    }, {
                        label: '注册时间',
                        property: 'created',
                        width: 150,
                        type: 'date',
                        columnKey: 'created', // 用于标识哪一列 用于单元格点击事件
                        sortable: true,
                    }, {
                        label: '用户标签',
                        slot: 'sign',
                        property: 'sign',
                        width: 100,
                        columnKey: 'sign'
                    }, {
                        label: '职位名称',
                        property: 'job',
                        width: 150,
                        type: 'select',
                        options: [
                            {
                                label: '开发',
                                value: '开发',
                            },
                            {
                                label: '运维',
                                value: '运维',
                            },
                            {
                                label: '管理',
                                value: '管理',
                            },] // key 保持与 property 一致
                    }, {
                        label: '工资',
                        property: 'wages',
                        width: 150,
                        type: 'number',
                    },
                ],
                tableData: [
                    {
                        id: '10086',
                        name: '王小虎',
                        email: '10086@qq.con',
                        state: '启用',
                        created: '2019-05-01',
                        sign: '普通用户',
                        job: '运维',
                        wages: 8000,
                    }, {
                        id: '10087',
                        name: '王小牛',
                        email: '10087@qq.con',
                        state: '禁用',
                        created: '2019-05-02',
                        sign: '普通用户',
                        job: '开发',
                        wages: 13000,
                    }, {
                        id: '10088',
                        name: '王小马',
                        email: '10087@qq.con',
                        state: '启用',
                        created: '2019-05-03',
                        sign: '管理员',
                        job: '管理',
                        wages: 25000,
                    }],
                // 树型表格数据
                tableData3: [
                    {
                        id: '10086',
                        name: '王小虎',
                        email: '10086@qq.con',
                        state: '启用',
                        created: '2019-05-01',
                        sign: '普通用户',
                        job: '运维',
                        wages: 8000,
                        children: [
                            {
                                id: '1008601',
                                name: '王小虎',
                                email: '1008601@qq.con',
                                state: '启用',
                                created: '2019-05-01',
                                sign: '普通用户',
                                job: '运维',
                                wages: 8000,
                            }, {
                                id: '1008602',
                                name: '王小牛',
                                email: '1008602@qq.con',
                                state: '禁用',
                                created: '2019-05-02',
                                sign: '普通用户',
                                job: '开发',
                                wages: 13000,
                                children: [
                                    {
                                        id: '100860201',
                                        name: '王小虎哥哥',
                                        email: '100860201@qq.con',
                                        state: '启用',
                                        created: '2019-05-01',
                                        sign: '普通用户',
                                        job: '运维',
                                        wages: 8000,
                                    }, {
                                        id: '100860202',
                                        name: '王小牛',
                                        email: '100860202@qq.con',
                                        state: '禁用',
                                        created: '2019-05-02',
                                        sign: '普通用户',
                                        job: '开发',
                                        wages: 13000,
                                    }, {
                                        id: '100860203',
                                        name: '王小马',
                                        email: '100860203@qq.con',
                                        state: '启用',
                                        created: '2019-05-03',
                                        sign: '管理员',
                                        job: '管理',
                                        wages: 25000,
                                    }]
                            }, {
                                id: '1008603',
                                name: '王小马',
                                email: '1008603@qq.con',
                                state: '启用',
                                created: '2019-05-03',
                                sign: '管理员',
                                job: '管理',
                                wages: 25000,
                            }]
                    }, {
                        id: '10087',
                        name: '王小牛',
                        email: '10087@qq.con',
                        state: '禁用',
                        created: '2019-05-02',
                        sign: '普通用户',
                        job: '开发',
                        wages: 13000,
                        children: [
                            {
                                id: '1008701',
                                name: '王小虎',
                                email: '1008701@qq.con',
                                state: '启用',
                                created: '2019-05-01',
                                sign: '普通用户',
                                job: '运维',
                                wages: 8000,
                            }, {
                                id: '1008702',
                                name: '王小牛',
                                email: '1008702@qq.con',
                                state: '禁用',
                                created: '2019-05-02',
                                sign: '普通用户',
                                job: '开发',
                                wages: 13000,
                            }, {
                                id: '1008703',
                                name: '王小马',
                                email: '1008703@qq.con',
                                state: '启用',
                                created: '2019-05-03',
                                sign: '管理员',
                                job: '管理',
                                wages: 25000,
                            }]
                    }, {
                        id: '10088',
                        name: '王小马',
                        email: '10087@qq.con',
                        state: '启用',
                        created: '2019-05-03',
                        sign: '管理员',
                        job: '管理',
                        wages: 25000,
                        children: [
                            {
                                id: '1008801',
                                name: '王小虎',
                                email: '1008801@qq.con',
                                state: '启用',
                                created: '2019-05-01',
                                sign: '普通用户',
                                job: '运维',
                                wages: 8000,
                            }, {
                                id: '1008802',
                                name: '王小牛',
                                email: '1008802@qq.con',
                                state: '禁用',
                                created: '2019-05-02',
                                sign: '普通用户',
                                job: '开发',
                                wages: 13000,
                            }, {
                                id: '1008803',
                                name: '王小马',
                                email: '1008803@qq.con',
                                state: '启用',
                                created: '2019-05-03',
                                sign: '管理员',
                                job: '管理',
                                wages: 25000,
                            }]
                    }]
            }
        },
        methods: {
            handleClick(scope, sign) {
                console.log(scope)
                const index = scope.data.scope.$index
                if (sign === 'edit') {
                    const obj = this.tableData[index]
                    if (obj.enableEdit) {
                        this.$delete(obj, 'enableEdit')
                    } else {
                        obj.enableEdit = true
                    }
                    this.$set(this.tableData, index, obj)
                } else if (sign === 'del') {
                    this.tableData.splice(index, 1)
                }
            },
            search(val) {
                console.log('搜索条件', val)
            },
            /**
             * 单元格合并方法
             * @param rowIndex  行索引
             * @param columnIndex  列索引
             * @returns {number[]}
             */
            spanMethod({rowIndex, columnIndex}) {
                if (columnIndex === 7) {
                    if (rowIndex % 2 === 0) {
                        return [2, 1]
                    } else {
                        return [0, 0]
                    }
                }
            },

            /**
             * 自定义单元格样式
             * @param rowIndex
             * @param columnIndex
             * @returns {string}
             */
            cellStyle({rowIndex, columnIndex}) {
                if (rowIndex === 1) {
                    return "background-color: #eaeaea"
                }
                if (columnIndex === 1) {
                    return "color: red";
                } else if (columnIndex === 3) {
                    return "color: blue";
                }
                return "";
            },
            /**
             * 自定义表尾合计方法
             * @param param
             * @returns {Array}
             */
            getSummaries(param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总计';
                        return;
                    }
                    if (index === 8) {
                        const values = data.map(item => Number(item[column.property]));
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = toThousandFilter(values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0));
                            sums[index] += ' 元';
                        } else {
                            sums[index] = '-';
                        }
                    } else {
                        sums[index] = '-';
                    }
                });

                return sums;
            },

            deleteData(val) {
                console.log(val)
                val.forEach(item => {
                    this.tableData = this.tableData.filter(i => i.id !== item.id)
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .data-table-box {
        padding: 15px;
        .title {
            padding: 20px 0;
        }
    }
</style>